// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"167":"6a1bbe83","349":"67889fcf","487":"9bbb9f4e","504":"dab11d2e","516":"b0dbafbf","780":"aebb3306","841":"34e4f730","870":"110dc22e"}[chunkId] + ".chunk.js";
};